import { render, staticRenderFns } from "./GrupoTabela.vue?vue&type=template&id=d2fe4528&lang=html"
import script from "./GrupoTabela.vue?vue&type=script&lang=js"
export * from "./GrupoTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports